module.exports = __webpack_public_path__ + "img/logo-text.07dd8180.png";